module.exports = __webpack_public_path__ + "static/img/shuiji5.f923039b.webp";